exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".attribute-edit {\n  height: 100%;\n}\n.attribute-edit .kng-drawer {\n  min-height: 450px;\n}\n.attribute-edit .input-sm {\n  max-width: 100px;\n}\n.attribute-edit .select-sm {\n  max-width: 250px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/dclean-web-latest/cot-web/src/app/components/things/attributes/edit.component.less
// module id = ../../../../../src/app/components/things/attributes/edit.component.less
// module chunks = main